import React, { useEffect, useState } from 'react';
import { fetchProducts } from '../contentful';
import ProductCard from './ProductCard';

const RecommendedProducts = ({ type = 'household' }) => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const allProducts = await fetchProducts(type === 'industrial' ? 'b2bCleaningProductData' : 'cleaningProductData');
        // Get 3 random products
        const shuffled = allProducts.sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, 3);
        setProducts(selected);
      } catch (error) {
        console.error('Error loading recommended products:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadProducts();
  }, [type]);

  if (isLoading) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">Loading recommended products...</div>
      </div>
    );
  }

  if (products.length === 0) return null;

  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 
          className="text-3xl font-bold text-center mb-12"
          style={{ fontFamily: "Geogrotesque, sans-serif" }}
        >
          Recommended Products
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <ProductCard 
              key={product.sys.id} 
              product={product} 
              type={type}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecommendedProducts; 